export default "__VITE_ASSET__LVD8uc4i__"